import React from 'react'
import { useTheme } from '../../../index'
import { LOGO_DARK, LOGO_LIGHT } from '../../../utils/constants'

const NotificationCenterFooter = () => {
  const theme = useTheme()
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '5px',
        background: theme.palette.background.paper,
        borderRadius: '0 0 10px 10px',
        padding: '0.4rem 0 0.3rem 0',
        flexShrink: 0,
        boxShadow: '0 -2px 5px 2px rgba(0, 0, 0, 0.08)'
      }}
    >
      <p
        style={{
          fontSize: '0.7rem',
          margin: 0,
          color: theme.palette.text.primary
        }}
      >
        Powered By
      </p>
      <img
        src={theme.palette.mode === 'light' ? LOGO_LIGHT : LOGO_DARK}
        alt='Fyno'
        width='45px'
        height='auto'
        className='poweredLogo'
      />
    </div>
  )
}

export default NotificationCenterFooter
